import {
  Desktop,
  Mobile,
} from "@lya-protect/lya-protect-form-library/dist/UI/Utils/BreakPoints";
import { MicroStep } from "@src/Steps/step/Steps";
import "./stepbar.scss";
import { ReactComponent as CheckCircle } from "@src/svg/check-circle.svg";
import { Ellipse } from "@src/svg/ellipse";

export type StepbarProps = {
  activeMicroStep: MicroStep;
};

type StepbarItemProps = {
  activeMicroStep: boolean;
  completed?: boolean;
  title: string;
  number: string;
};

function StepbarItem({
  activeMicroStep,
  completed = false,
  number,
  title,
}: StepbarItemProps) {
  const accentColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--accent-secondary-color");

  return (
    <div className="stepbar__progress-container">
      <p className="stepbar__progress-item" data-active={activeMicroStep}>
        <span>
          {completed ? (
            <CheckCircle className="stepbar__progress-check" />
          ) : (
            number
          )}
        </span>
        {title}
      </p>
      <div className="stepbar__progress-line_wrapper">
        <Ellipse
          className="stepbar__progress-dot"
          color={activeMicroStep ? accentColor : "#92939B"}
          data-active={activeMicroStep}
        />
        <span className="stepbar__progress-line" />
      </div>
    </div>
  );
}

export function Stepbar({ activeMicroStep }: StepbarProps) {
  return (
    <div className="stepbar">
      <Desktop>
        <div className="stepbar__progress">
          <StepbarItem
            activeMicroStep={activeMicroStep === MicroStep.PersonalInformation}
            completed={activeMicroStep > MicroStep.PersonalInformation}
            title="Informations personnelles"
            number="01"
          />
          <StepbarItem
            activeMicroStep={activeMicroStep === MicroStep.Payment}
            completed={activeMicroStep > MicroStep.Payment}
            title="Paiement"
            number="02"
          />
          <StepbarItem
            activeMicroStep={activeMicroStep === MicroStep.SupportingDocuments}
            completed={activeMicroStep > MicroStep.SupportingDocuments}
            title="Pièces justificatives"
            number="03"
          />
          <StepbarItem
            activeMicroStep={activeMicroStep === MicroStep.Signature}
            title="Signature"
            number="04"
          />
        </div>
      </Desktop>
      <Mobile>
        <div className="stepbar__progress">
          {activeMicroStep === MicroStep.PersonalInformation && (
            <StepbarItem
              activeMicroStep
              title="Informations personnelles"
              number="01"
            />
          )}
          {activeMicroStep === MicroStep.Payment && (
            <StepbarItem activeMicroStep title="Paiement" number="02" />
          )}
          {activeMicroStep === MicroStep.SupportingDocuments && (
            <StepbarItem
              activeMicroStep
              title="Pièces justificatifs"
              number="03"
            />
          )}
          {activeMicroStep === MicroStep.Signature && (
            <StepbarItem activeMicroStep title="Signature" number="04" />
          )}
        </div>
      </Mobile>
    </div>
  );
}
